<template>
  <div>
    <template v-if="employmentPoliciesReport">
      <template v-for="(chartData, key) in charts">
        <b-row v-if="chartData.type == 'Table'" :key="key">
          <b-col>
            <card-chart-indicator
              :chart-data="chartData"
              :alias="alias + key"
              :height="height"
            />
          </b-col>
        </b-row>
      </template>
    </template>
    <template v-else>
      <template v-if="singleChart">
        <template v-for="(chartData, key) in charts">
          <b-row v-if="key < maxCharts" :key="key">
            <b-col>
              <card-chart-indicator
                :chart-data="chartData"
                :alias="alias + key"
                :height="height"
              />
            </b-col>
          </b-row>
        </template>
      </template>
      <template v-else>
        <template v-for="(chartData, key) in charts">
          <b-row
            v-if="firstChart <= key && key < maxCharts + firstChart"
            :key="key"
          >
            <b-col>
              <card-chart-indicator
                :chart-data="chartData"
                :alias="alias + key"
                :height="height"
              />
            </b-col>
          </b-row>
        </template>
      </template>
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "CardChartsIndicator",
  props: {
    pillarId: {
      default: "",
    },
    indicatorId: {
      default: "",
    },
    alias: {
      default: "",
    },
    height: {
      type: String,
      default: "auto",
    },
    maxCharts: {
      type: Number,
      default: 1000,
    },
    firstChart: {
      type: Number,
      default: 1000,
    },
    singleChart: {
      type: Boolean,
      default: true,
    },
    employmentPoliciesReport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      indicator: {},
      charts: [],
    };
  },
  watch: {
    indicatorId: function () {
      this.updateData();
    },
  },
  methods: {
    updateData() {
      this.indicator = this.getIndicatorData(this.pillarId, this.indicatorId);
      if (this.indicator) {
        this.charts = this.indicator.chart;
      }
    },
  },
  computed: mapGetters(["getIndicatorData"]),
  mounted() {
    this.updateData();
  },
};
</script>
